import React, { useState } from "react";
import DownloadAttach from "./download_file/DownloadAttach";
import "./uploadQuestion.css";
import AttachmentDefault from "../../Create_Assessment/Create_Question/Create_Q_Type/AttachmentDefault";
import CrossAttachmentAssessment from "../../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";
import { Box, Paper, Typography, Stack, Divider } from "@mui/material";
const UploadQuestion = (para) => {
  const [click, setClick] = useState(false);
  console.log(para?.currentQuestion?.correct_ans);
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        borderRadius: 3,
        border: "1px solid #e5e7eb",
        mb: 4,
      }}
    >
      {/* QUESTION */}
      <Stack spacing={1}>
        <Typography
          fontWeight={700}
          sx={{ color: "#001A6E", fontSize: "18px" }}
        >
          Q{para.currentQuestionIndex + 1}.
        </Typography>

        <Typography fontWeight={600} lineHeight={1.6}>
          {para.currentQuestion.question_title
            ?.split("\n")
            .map((line, index) => (
              <span key={index}>
                {index !== 0 && <br />}
                {line}
              </span>
            ))}
          {para.currentQuestion?.is_mandatory === "true" && (
            <span style={{ color: "brown", marginLeft: 6 }}>*mandatory</span>
          )}
        </Typography>
      </Stack>

      {/* TEACHER ATTACHMENTS */}
      {para.currentQuestion.teacher_attachment?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} flexWrap="wrap">
          {para.currentQuestion.teacher_attachment.map((attachment, index) => (
            <AttachmentDefault
              key={index}
              attach={attachment}
              fileSize={para.currentQuestion.attachments_sizeKb[index]}
            />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 3 }} />

      {/* STUDENT ANSWER */}
      <Typography fontWeight={600} sx={{ color: "#001A6E", fontSize: "16px" }}>
        Student Answer
      </Typography>

      <Box
        sx={{
          mt: 1.5,
          p: 2,
          borderRadius: 2,
          backgroundColor: "#f9fafb",
          border: "1px solid #e5e7eb",
        }}
      >
        <Typography>
          {para.currentQuestion.descriptive_answer || "No Answer"}
        </Typography>
      </Box>

      {/* STUDENT ATTACHMENTS */}
      {para.currentQuestion.student_attachment?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} flexWrap="wrap">
          {para.currentQuestion.student_attachment.map((attachment, index) => (
            <AttachmentDefault
              key={index}
              attach={attachment}
              className="ansAttach"
              fileSize={para.currentQuestion.attachments_sizeKb[index]}
            />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 3 }} />

      {/* TEACHER COMMENT */}
      <Typography fontWeight={600}>Teacher Comment</Typography>

      <Box
        sx={{
          mt: 1,
          p: 2,
          borderRadius: 2,
          border: "1px solid #e5e7eb",
          backgroundColor: "#fff",
        }}
      >
        <Typography>{para.currentQuestion.comment || "-"}</Typography>
      </Box>

      {/* MARKS */}
      <Stack direction="row" spacing={2} mt={2} alignItems="center">
        <Typography>
          Allot marks out of {para.currentQuestion.totalM}
        </Typography>

        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: 1,
            border: "1px solid #d1d5db",
            minWidth: 80,
            textAlign: "center",
          }}
        >
          {para.currentQuestion.obtained_marks}
        </Box>
      </Stack>

      {/* CORRECT ANSWER */}
      {para.currentQuestion.correct_ans && (
        <>
          <Divider sx={{ my: 3 }} />

          <Typography fontWeight={600}>Correct Answer</Typography>

          {para.currentQuestion.correct_ans.reason_for_answer?.explanation && (
            <Box
              sx={{
                mt: 1.5,
                p: 2,
                borderRadius: 2,
                backgroundColor: "#f0fdf4",
                border: "1px solid #16a34a",
              }}
            >
              {para.currentQuestion.correct_ans.reason_for_answer.explanation}
            </Box>
          )}

          {para.currentQuestion.correct_ans.reason_for_answer?.attachment && (
            <Box mt={2}>
              <AttachmentDefault
                attach={
                  para.currentQuestion.correct_ans.reason_for_answer.attachment
                }
                className="ansAttach"
                fileSize={para.currentQuestion.attachments_sizeKb[0]}
              />
            </Box>
          )}
        </>
      )}
    </Paper>
  );
};

export default UploadQuestion;
